export const handleFocus = {
  methods: {
    handleFocus(event) {
      if (!event || !event.target || typeof event.target.scrollIntoView !== 'function') {
        return;
      }
      const target = event.target;
      setTimeout(() => {
        try {
          if (target && typeof target.scrollIntoView === 'function') {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } catch (error) {
          console.error('Error in handleFocus:', error);
        }
      }, 300);
    }
  }
};
